export const dispatchEvent = (name, detail, scope=document) => {
    const event = new CustomEvent(name, { detail })
    scope.dispatchEvent(event)
    return event
}